<template>
<div class="navbar-container">
  <hamburger class="hamburger-container"></hamburger>
  <breadcrumb class="breadcrumb-container"></breadcrumb>
  <div class="right-menu">
    <el-dropdown class="language-switch right-menu-item hover-effect" trigger="click" placement="bottom-end" data-i18n-ignore="true">
      <button type="button" class="language-button" :aria-label="$t('语言')">
        <i class="el-icon-sort language-icon" aria-hidden="true" />
        <span>{{ $locale === 'en' ? 'EN' : '中文' }}</span>
        <i class="el-icon-arrow-down language-arrow" aria-hidden="true" />
      </button>
      <el-dropdown-menu slot="dropdown" class="language-dropdown">
        <el-dropdown-item :class="{ 'language-selected': $locale === 'zh' }" @click.native="$setLocale('zh')">中文</el-dropdown-item>
        <el-dropdown-item :class="{ 'language-selected': $locale === 'en' }" @click.native="$setLocale('en')">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <template v-if="device!=='mobile'">
      <el-tooltip effect="dark" :content="$t('全屏展示')" placement="bottom">
        <screen-full class="right-menu-item hover-effect"></screen-full>
      </el-tooltip>
    </template>

    <customer-notices v-if="roles === 'ROLE_DEFAULT'" />

    <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" size="small">
      <div class="avatar-wrapper">
        <img :src="avatar" class="user-avatar">
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu slot="dropdown" class="dropdown-menu-item">
        <router-link to="/user/profile">
          <el-dropdown-item icon="el-icon-setting">{{ $t('个人中心') }}</el-dropdown-item>
        </router-link>
        <el-dropdown-item icon="el-icon-switch-button" divided @click.native="logout">
          <span>{{ $t('退出登录') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</div>
</template>

<script>
import { getLoginPath } from '../utils/loginEntry'
import { translateUi } from '../i18n'
import ScreenFull from '../components/ScreenFull/index.vue'
import Hamburger from './components/Hamburger.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import CustomerNotices from './components/CustomerNotices.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',

  components: { Hamburger, Breadcrumb, ScreenFull, CustomerNotices },

  computed: {
    ...mapGetters(['avatar', 'device', 'isCollapse', 'roles'])
  },

  methods: {
    /**
     * 用户退出方法
     */
    async logout () {
      this.$confirm(translateUi('确定注销并退出系统吗？'), translateUi('提示'), {
        confirmButtonText: translateUi('确定'),
        cancelButtonText: translateUi('取消'),
        type: 'warning'
      }).then(() => {
        const loginPath = getLoginPath(this.roles)
        this.$store.dispatch('user/logout').then(() => {
          location.href = loginPath
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-container {
  height: 56px;
  border-bottom: 1px solid #e2ebe8;
  box-shadow: 0 2px 8px rgba(20, 59, 55, .05);
  background: #fff;
}

.hamburger-container {
  float: left;
  height: 100%;
  line-height: 54px;
  padding: 0 15px;
  cursor: pointer;
  // hover 动画
  transition: background 0.5s;

  &:hover {
    background-color: #edf7f4;
  }
}

.breadcrumb-container {
  float: left;
  height: 100%;
  line-height: 56px;
  margin-left: 0.5rem;
}

.right-menu {
  float: right;
  height: 100%;
  line-height: 54px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    color: #4d625e;
    vertical-align: text-bottom;

    &.svg-icon {
      font-size: 18px;
    }

    &.hover-effect {
      cursor: pointer;
      transition: background .3s;
      &:hover {
        background: #edf7f4
      }
    }
  }

  .language-switch {
    padding: 0 10px;
  }

  .language-button {
    display: inline-flex;
    align-items: center;
    height: 100%;
    border: 0;
    padding: 0;
    color: inherit;
    background: transparent;
    font-size: 12px;
    cursor: pointer;
  }

  .language-icon {
    margin-right: 5px;
    font-size: 15px;
    transform: rotate(90deg);
  }

  .language-arrow {
    margin-left: 5px;
    font-size: 10px;
  }

  .avatar-container {
    margin-right: 32px;

    .avatar-wrapper {
      margin-top: 8px;
      position: relative;
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid #e5f3ef;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

.dropdown-menu-item {
  width: 120px;
  margin-right: -20px;
}

.language-dropdown {
  min-width: 118px;
}

.language-dropdown .language-selected {
  color: #176c61;
  background: #edf7f4;
  font-weight: 600;
}
@media (max-width: 700px) {
  .navbar-container .breadcrumb-container { display: none; }
  .right-menu .avatar-container { margin-right: 16px; }
  .right-menu .language-switch { padding: 0 6px; }
  .right-menu .right-menu-item { padding: 0 5px; }
  .language-button { min-width: 46px; }
}
</style>
